
export default {
  name: 'ProductMediaGallery',

  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    zoom: false,
    active: 0,
    imgLoaded: false,

    zoomImg: false,

    dragging: false,
    moved: false,
    startX: 0,
    startY: 0,
    initialX: 0,
    initialY: 0,
  }),

  computed: {
    isStart () {
      return this.active === 0
    },

    isEnd () {
      return this.active === this.gallery.length - 1
    },

    gallery () {
      return this.product.mediaGallery.length
        ? this.product.mediaGallery
        : [this.product.image]
    },
  },

  mounted () {
    window.addEventListener('keydown', this.onKeydown)
  },

  destroyed () {
    window.removeEventListener('keydown', this.onKeydown)
  },

  methods: {
    onKeydown (e) {
      if (e.key === 'Escape') {
        this.setZoomOverlay(false)
      }
    },

    onImageLoaded () {
      this.imgLoaded = true
    },

    setActive (index) {
      if (index < 0 || index > this.gallery.length - 1) {
        return
      }

      this.active = index
      this.scrollImage()
    },

    onScroll (e) {
      const scroll = e.target.scrollLeft + 10
      const items = Array
        .from(this.$refs.images.querySelectorAll('li'))
        .map(e => e.offsetLeft).reverse()

      const index = items.findIndex(e => scroll >= e)

      this.active = items.length - index - 1
      this.scrollThumbs()
    },

    scrollThumbs () {
      const thumb = document.getElementById(`thumb-${this.active}`)

      if (thumb) {
        this.$refs.thumbs.scroll({
          top: thumb.offsetTop,
          behavior: 'smooth',
        })
      }
    },

    scrollImage () {
      const image = document.getElementById(`image-${this.active}`)

      if (image) {
        this.$refs.images.scroll({
          left: image.offsetLeft,
          behavior: 'instant',
        })
      }
    },

    onMousedown (e) {
      if (!this.zoomImg) {
        return
      }

      const img = document.getElementById('draggable')

      this.isDragging = true
      this.moved = false
      this.startX = e.clientX || e.touches?.[0].clientX
      this.startY = e.clientY || e.touches?.[0].clientY
      this.initialX = parseInt(img.style.left) || 0
      this.initialY = parseInt(img.style.top) || 0
    },

    onMousemove (e) {
      if (this.isDragging && (e.buttons === 1 || e.touches?.length)) {
        const img = document.getElementById('draggable')

        const clientX = e.clientX || e.touches?.[0].clientX
        const clientY = e.clientY || e.touches?.[0].clientY

        const dx = this.initialX + clientX - this.startX
        const dy = this.initialY + clientY - this.startY

        this.moved = true

        if (Math.abs(dx) <= img.width / 2) {
          img.style.left = `${dx}px`
        }

        if (Math.abs(dy) <= img.height / 2) {
          img.style.top = `${dy}px`
        }
      }
    },

    onMouseup () {
      this.isDragging = false
    },

    setZoom () {
      if (this.moved) {
        return
      }

      const img = document.getElementById('draggable')

      img.style.left = null
      img.style.top = null

      this.zoomImg = !this.zoomImg
    },

    setZoomOverlay (zoom) {
      this.zoom = zoom
      this.zoomImg = false
    },
  },
}
